import type { AllHTMLAttributes, ReactNode } from "react";

import styles from "./tabs-nav.module.css";

export type TabsNavProps = {
  children: ReactNode;
} & AllHTMLAttributes<HTMLDivElement>;

export function TabsNav({ children, ...props }: TabsNavProps) {
  return (
    <div {...props} className={styles.Container}>
      {children}
    </div>
  );
}
